import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Map, Calendar, MapPin, Settings, Layout } from 'lucide-react';

interface NavItem {
  icon: React.ComponentType<{ className?: string }>;
  path: string;
  label: string;
}

const CreatorSidebar: React.FC = () => {
  const location = useLocation();

  const navItems: NavItem[] = [
    { icon: Layout, path: '/creator-studio', label: 'Dashboard' },
    { icon: Map, path: '/creator-studio/map', label: 'Map' },
    { icon: Calendar, path: '/creator-studio/calendar', label: 'Calendar' },
    { icon: MapPin, path: '/creator-studio/locations', label: 'Locations' },
    { icon: Settings, path: '/creator-studio/settings', label: 'Settings' },
  ];

  const isActive = (path: string) => {
    if (path === '/creator-studio') {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <aside className="fixed left-0 top-0 h-screen w-16 bg-creator-surface dark:bg-gray-900 shadow-md z-40 flex flex-col items-center py-6 border-r border-creator-border dark:border-gray-700">
      {/* Brand Icon */}
      <div className="mb-8">
        <Link to="/creator-studio" className="flex items-center justify-center">
          <div className="w-10 h-10 bg-creator-accent rounded-lg flex items-center justify-center shadow-sm">
            <Home className="w-6 h-6 text-white" />
          </div>
        </Link>
      </div>

      {/* Navigation Icons */}
      <nav className="flex-1 flex flex-col items-center space-y-4">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`
                w-12 h-12 rounded-lg flex items-center justify-center transition-all duration-200
                ${active 
                  ? 'bg-creator-accent text-white shadow-md' 
                  : 'text-creator-text hover:bg-creator-bg dark:text-gray-400 dark:hover:bg-gray-800'
                }
              `}
              title={item.label}
              aria-label={item.label}
            >
              <Icon className="w-5 h-5" />
            </Link>
          );
        })}
      </nav>

      {/* Bottom Spacer */}
      <div className="mt-auto" />
    </aside>
  );
};

export default CreatorSidebar;
